import { ITrainingGroupRequirementsValues } from './training-group-requirements-form-types'
import {
  ITrainingGroupRequirementsAddUpsert
} from '../../../../interfaces'

export const trainingGroupRequirementsValuesToTrainingGroupRequirementsAddUpsert = (
  trainingGroupRequirementsValues: ITrainingGroupRequirementsValues,
): ITrainingGroupRequirementsAddUpsert | undefined => {
  if (!trainingGroupRequirementsValues || !trainingGroupRequirementsValues?.trainingGroupId) {
    return undefined
  }

  return {
    trainingGroupId: trainingGroupRequirementsValues?.trainingGroupId,
    trainingTypeIds: trainingGroupRequirementsValues?.trainingTypeIds ?? [],
  }
}